var _circle, _path, _g, _g2, _g3, _polygon, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438.81,
    height: 316.07,
    viewBox: "0 0 438.81 316.07",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.254,
    cy: 310.07,
    r: 5.5179,
    fill: "#3f3d56",
    strokeWidth: 0.78827
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.8 151.08c0.46222-1.563 1.2391-2.892 2.1572-3.8362l3.4628-15.168 7.1693 1.8589-4.2846 15.186c0.25692 1.2916 0.18612 2.8294-0.27619 4.3925-1.056 3.5707-3.754 5.9206-6.0263 5.2486-2.2723-0.67195-3.2583-4.1113-2.2023-7.682z",
    fill: "#ffb6b6",
    strokeWidth: 0.78827
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78827 0 0 .78827 0 2.6078e-6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.07 378.76 115.46 378.96 110.67 340.29 123.37 339.99",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.54 396.72c0 1.4541 1.0319 2.6329 2.3048 2.6329h17.085s1.6813-6.7585 8.5364-9.6671l0.47312 9.6671h8.8137l-1.0679-15.544s2.3577-8.3162-2.5388-12.567c-4.8965-4.251-0.93052-3.6592-0.93052-3.6592l-1.9262-9.6207-13.318 1.5662-0.0979 15.102-6.4633 14.99-9.4802 4.683c-0.84378 0.4168-1.39 1.3665-1.39 2.4166l-1.1e-4 3e-5z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.466 368.65 58.858 368.85 54.06 330.18 66.763 329.88",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.934 386.61c0 1.4541 1.0319 2.6329 2.3048 2.6329h17.085s1.6813-6.7585 8.5364-9.6671l0.47312 9.6671h8.8137l-1.0679-15.544s2.3577-8.3162-2.5388-12.567c-4.8965-4.251-0.93052-3.6592-0.93052-3.6592l-1.9262-9.6207-13.318 1.5662-0.09793 15.102-6.4633 14.99-9.4802 4.683c-0.84378 0.4168-1.39 1.3665-1.39 2.4166l-1.1e-4 3e-5z",
    fill: "#2f2e41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.78827
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.701 55.571-24.435 4.2496c-1.6834-4.3085-12.985-33.54-13.683-37.758-1.8147-10.967 6.3622-21.078 17.448-21.906h3.9e-5c10.632-0.79345 17.11 1.1977 18.015 11.325 0.31716 3.5497 3.3633 13.059 4.2943 16.499 5.136 18.979-0.40993 23.546-1.6383 27.59z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.861 117.72-1.5936 24.435-15.139 75.165 1.0624 52.589 13.811-2.1248 4.2496-48.339 23.981-54.448 3.1098 112.88 14.874 0.5312 10.453-132.56c0.79867-10.129-1.8559-20.229-7.5314-28.656v-1e-5z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.671 39.104h-19.495l-4.4085 6.9056-15.405 6.3744 8.4992 60.557-2.1248 26.029c12.01 4.075 39.88 10.382 60.039-6.2642l-18.074-32.513 4.2496-45.683-8.2336-7.4912z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.314 50.525s-9.0304-3.7184-13.28 3.1872c-2.3126 3.7579-6.6701 29.539-10.162 52.261-2.9249 19.032-5.2426 35.918-5.2426 35.918l9.296 1.328 18.326-65.603z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.885,
    cy: 20.941,
    r: 14.729,
    fill: "#ffb6b6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78827 0 0 .78827 0 2.6078e-6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.6 376.97 406.89 382.06 430.98 348.65 417.26 341.13",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.55 394.22c0.0219 0.64593-0.68834 2.3021-0.99925 2.8687-0.95565 1.7414-3.1421 2.3785-4.8836 1.4228l-28.771-15.789c-1.188-0.65194-1.6226-2.1435-0.97066-3.3316l0.65734-1.1978s0.55235-4.3812 5.9177-7.2105c0 0 1.7353 5.4731 10.164 3.0175l3.2002-2.0266 6.9544 14.871 6.004 4.326c1.3136 0.94643 2.6724 1.4315 2.7273 3.0496l1.1e-4 6e-5z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.66 392.75 427.26 392.75 432.3 351.87 416.66 351.87",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.97 392.51c0.32997 0.55572 0.50407 2.3494 0.50407 2.9956 0 1.9864-1.6103 3.5968-3.5968 3.5968h-32.819c-1.3551 0-2.4538-1.0986-2.4538-2.4538v-1.3664s-1.6235-4.1066 1.719-9.1682c0 0 4.1543 3.9633 10.362-2.2443l1.8306-3.3162 13.251 9.691 7.3447 0.90407c1.6069 0.19777 3.0315-0.0307 3.8581 1.3614h1.3e-4z",
    fill: "#2f2e41"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.78827 0 0 .78827 0 2.6078e-6)",
    points: "420.03 200.52 414.32 367.98 434.4 367.98 456.1 213.66 456.1 294.73 410.27 344.4 424.8 354.5 486.02 297.06 497.2 186.71 488.44 170.54 424.43 169.86",
    fill: "#2f2e41"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.78827
  }, /*#__PURE__*/React.createElement("path", {
    d: "m371.48 37.999-14.918-0.67481-4.7361 7.5804-19.7 9.7616 2.702 58.232-5.312 26.56s49.77 18.06 62.519 7.4361l-3.5556-37.714 2.7673-53.725-12.86-6.3003z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.36,
    cy: 18.581,
    r: 15.428,
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.16 31.185c1.1203 0.10945 1.1838 2.2777 2.2487 2.6037 0.97392 0.29814 2.6732-0.97893 2.8404-2.367 0.13329-1.1062-0.80328-1.4782-2.1303-3.7872-0.78012-1.3574 0.4867-0.99292 0.44161-2.9224-0.0143-0.57465-2.1282-4.068-1.0334-5.5988 0.36236-0.50664 0.87589-1.2247 1.7753-1.5386 1.3534-0.47233 2.0802 0.49403 3.7872 0.59176 1.6318 0.09336-1.0551 1.6384 0.83611 0.42699 1.9334-1.2384 2.667-4.4555 2.656-5.8432-0.0115-1.4276-0.32911 1.2642 0 0 0.16593-0.63727 6.6394 5.0596 6.9559 4.8673 2.0387-1.2383 3.0634-3.5601 5.2616-2.2113 2.3851 1.4635 3.4653 0.88005 4.2496 0.53119 0.64417-0.28654 0.11357-5.7595-0.0763-6.6473-0.52217-2.4421-3.223-3.5839-3.4322-3.6689-1.397-0.5671-1.9085-0.15293-2.7221-0.82844-1.1555-0.95941-0.49859-2.106-1.4202-3.0771-1.0151-1.0697-2.2072 0.88921-6.5901 0.92476-2.8172 0.022899-2.9303-1.6039-4.4166-1.5165-1.2329 0.072582-5.3256 0.31318-8.9947 3.1955-3.9718 3.1201-5.0228 7.4311-5.3258 8.758-0.7081 3.1008-0.99754 8.6283 1.6569 11.598 0.63644 0.71211 1.6104 1.4654 2.012 2.9588 0.45289 1.6841-0.0709 3.3833 0.59174 3.6689 0.27782 0.11975 0.41685-0.15856 0.82846-0.11839z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 315.13c0 0.52028 0.41781 0.93803 0.9381 0.93803h436.93c0.52022 0 0.93803-0.41775 0.93803-0.93803 0-0.52025-0.41781-0.93806-0.93803-0.93806h-436.93c-0.52028 0-0.9381 0.41781-0.9381 0.93806z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.11 147.68h-225.41c-8.269 0-14.993 6.724-14.993 14.993v137.13c0 8.269 6.724 14.993 14.993 14.993h225.41c8.269 0 14.993-6.724 14.993-14.993v-137.13c0-8.269-6.724-14.993-14.993-14.993z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.11 147.68h-225.41c-8.269 0-14.993 6.724-14.993 14.993v137.13c0 8.269 6.724 14.993 14.993 14.993h225.41c8.269 0 14.993-6.724 14.993-14.993v-137.13c0-8.269-6.724-14.993-14.993-14.993zm13.416 106.66c0 32.519-26.362 58.881-58.881 58.881h-179.95c-7.4097 0-13.416-6.0067-13.416-13.416v-137.13c0-7.4096 6.0067-13.416 13.416-13.416h225.41c7.4097 0 13.416 6.0067 13.416 13.416z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.25 153.1c-0.31658-1.5989-0.24578-3.1367 0.12868-4.3992l-3.9779-15.041 7.2125-1.6835 3.2586 15.439c0.82741 1.0245 1.4789 2.4194 1.7954 4.0182 0.72323 3.6527-0.57482 6.9868-2.8992 7.447-2.3244 0.46025-4.795-2.1277-5.5182-5.7804z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.123 51.056s9.0304-3.7184 13.28 3.1872c4.2496 6.9056 15.405 88.179 15.405 88.179l-9.296 1.328-18.326-65.603z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.74 155.49c0.21793-1.6282 0.78332-3.0725 1.5475-4.1557l-1.7357-35.238 13.192-1.7616-4.8842 37.878c0.45244 1.2457 0.61809 2.7877 0.40016 4.4159-0.49786 3.7196-2.8087 6.48-5.1615 6.1657-2.3527-0.31435-3.8564-3.5845-3.3585-7.304z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.59 56.069s-12.502-4.7217-16.66-0.44188c-4.1581 4.2799-17.96 51.989-17.96 51.989l1.293 35.532 9.8487-1.6996 23.479-85.379z",
    fill: "#ffc107"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#e6e6e6",
    strokeWidth: 0.78827
  }, /*#__PURE__*/React.createElement("path", {
    d: "m193.41 282.23h-22.119c-1.1114 0-2.018 0.90654-2.018 2.018 0 1.1193 0.90651 2.0259 2.018 2.0259h22.119c1.1114 0 2.018-0.90653 2.018-2.0259 0-1.1114-0.90651-2.018-2.018-2.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.46 282.23h-22.119c-1.1114 0-2.018 0.90654-2.018 2.018 0 1.1193 0.90652 2.0259 2.018 2.0259h22.119c1.1114 0 2.018-0.90653 2.018-2.0259 0-1.1114-0.90654-2.018-2.018-2.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.51 282.23h-22.119c-1.1114 0-2.018 0.90654-2.018 2.018 0 1.1193 0.90655 2.0259 2.018 2.0259h22.119c1.1114 0 2.018-0.90653 2.018-2.0259 0-1.1114-0.90654-2.018-2.018-2.018z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78827 0 0 .78827 0 2.6078e-6)",
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m452.84 94.349c0-5.2383 4.2617-9.5 9.5-9.5s9.5 4.2617 9.5 9.5-4.2617 9.5-9.5 9.5-9.5-4.2617-9.5-9.5zm1 0c0 4.6865 3.813 8.5 8.5 8.5s8.5-3.8135 8.5-8.5-3.813-8.5-8.5-8.5-8.5 3.8135-8.5 8.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.34,
    cy: 94.349,
    r: 5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.78827
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.36 80.465c1.0315 1.262 1.6925 2.6524 1.9559 3.9426l26.732 22.617-7.7325 10.797-24.124-29.224c-1.2121-0.51487-2.4431-1.4393-3.4746-2.7013-2.3565-2.883-2.7795-6.4359-0.94484-7.9354 1.8347-1.4996 5.2323-0.37806 7.5888 2.505z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.96 55.794s7.4368-3.7184 11.686 2.656c4.2496 6.3744 8.5745 39.328 8.5745 39.328s5.2367 22.822-4.8561 22.291c-10.093-0.53119-28.617-29.036-28.617-29.036l7.0944-6.3062 0.80613-7.6845z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.079 2.5009c-5.9914 1.0543-11.797 4.2981-14.906 9.5275-3.1083 5.2294-8.8035 12.516-4.6745 16.983 1.4271 1.5441 3.2453 2.713 4.529 4.3782 2.1846 2.8337 2.5001 6.815 1.4107 10.223-1.0894 3.4081-3.4256 6.298-6.0983 8.6767 5.7211-0.59021 10.942-4.6547 12.918-10.056 0.91428-2.4995 1.1004-5.4977-0.4641-7.6508-0.82277-1.1324-2.0346-1.9065-3.0797-2.8376-2.6955-2.4016-0.96435-6.0291-0.94832-9.6392 0.01553-3.6101 0.47052-6.1216 3.1872-8.4992 1.871 1.4953 8.0748 1.1343 10.439 0.75068 2.3641-0.38362 8.9757 8.6962 10.278 6.6861 2.5491 3.2766 0.805-3.4754 0.32644 0.6483-0.34237 2.9502-2.2795 5.4949-2.8635 8.4069-0.50821 2.534 0.04716 5.1709 0.93994 7.5963 2.0138 5.4711 5.7893 10.278 10.627 13.531-2.7934-3.9509-5.7058-8.2685-5.6139-13.106 0.06812-3.5883 6.1368-10.994 7.2075-14.42 2.0487-6.5548-2.0129-13.818-6.3744-19.123-3.8302-4.6586-11.234-3.2191-17.105-1.8398",
    fill: "#2f2e41"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78827 0 0 .78827 0 2.6078e-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m337.93 277.75c4.545 3.9883-0.95987 11.87-2.7347 17.325-2.7651 8.4995-11.493 13.556-20.294 12-6.8177-1.205-13.679-2.0566-20.581-2.5457-7.3599-0.52002-14.76-0.63-22.22-0.33002-7.75 0.31-15.55 1.08-23.42 2.31l-0.1317 0.0204c-9.0316 1.4051-17.687-4.0194-20.297-12.779-1.5105-5.0696-6.2064-12.023-2.3213-16.001 11.991-12.278 5.6188-16.382 4.2084-21.332-2.2108-7.7592 10.652-12.007 18.678-11.188 0.33445 0.0341 0.6689 0.0677 1.0034 0.1007 11.85 1.17 23.7 1.63 35.55 1.38 2.98-0.05 5.97-0.16003 8.95-0.31 6.7594-0.33318 13.515-0.89624 20.271-1.6918 7.8514-0.92448 21.629 3.2319 18.639 10.55-3.0808 7.5406-3.4198 15.367 4.6997 22.492z",
    fill: "#ffc107",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.32 246.4v58.13c-7.3599-0.52002-14.76-0.63-22.22-0.33002-7.75 0.31-15.55 1.08-23.42 2.31 1.05-9.73 0.38013-19.63 7.8901-23.26 9.29-4.5 1.04-22.67-6.75-37.92 11.85 1.17 23.7 1.63 35.55 1.38 2.98-0.05 5.97-0.16003 8.95-0.31z",
    fill: "#3f3d56",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.93 277.75c4.4592 4.0841-0.95987 11.87-2.7347 17.325-2.7651 8.4995-11.493 13.556-20.294 12-6.8177-1.205-13.679-2.0566-20.581-2.5457-7.3599-0.52002-14.76-0.63-22.22-0.33002-6.98-9.01-9.6502-17.28-3.23-22.49 7.27-5.89 9.8-20.37 16.5-35 2.98-0.05 5.97-0.16003 8.95-0.31 6.7594-0.33318 13.515-0.89624 20.271-1.6918 7.8514-0.92448 21.966 3.3787 18.639 10.55-3.2974 7.1082-3.7076 14.791 4.6997 22.492z",
    fill: "#ff6884",
    opacity: 0.7
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56",
    strokeWidth: 0.78827
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212.53 231.35h-22.119c-1.1114 0-2.018 0.90653-2.018 2.018 0 1.1193 0.90654 2.0259 2.018 2.0259h22.119c1.1114 0 2.018-0.90654 2.018-2.0259 0-1.1114-0.90655-2.018-2.018-2.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.94 217.16h-22.119c-1.1114 0-2.018 0.90653-2.018 2.018 0 1.1193 0.90652 2.0259 2.018 2.0259h22.119c1.1114 0 2.018-0.90653 2.018-2.0259 0-1.1114-0.90651-2.018-2.018-2.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.2 203.76h-22.119c-1.1114 0-2.018 0.90654-2.018 2.018 0 1.1193 0.90653 2.0259 2.018 2.0259h22.119c1.1114 0 2.018-0.90652 2.018-2.0259 0-1.1114-0.90652-2.018-2.018-2.018z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78827 0 0 .78827 0 2.6078e-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.72,
    y: 289.31,
    width: 104.01,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.73 299.16c-5.2383 0-9.5-4.2617-9.5-9.5s4.2617-9.5 9.5-9.5 9.5 4.2617 9.5 9.5-4.2617 9.5-9.5 9.5zm0-18c-4.687 0-8.5 3.8135-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.8135 8.5-8.5-3.813-8.5-8.5-8.5z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.73,
    cy: 289.66,
    r: 5,
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.94,
    y: 284.31,
    width: 104.01,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.44 284.66c0-5.2383 4.2617-9.5 9.5-9.5s9.5 4.2617 9.5 9.5-4.2617 9.5-9.5 9.5-9.5-4.2617-9.5-9.5zm1 0c0 4.6865 3.813 8.5 8.5 8.5s8.5-3.8135 8.5-8.5-3.813-8.5-8.5-8.5-8.5 3.8135-8.5 8.5z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.94,
    cy: 284.66,
    r: 5,
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.72,
    y: 253.31,
    width: 104.01,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.73 263.16c-5.2383 0-9.5-4.2617-9.5-9.5s4.2617-9.5 9.5-9.5 9.5 4.2617 9.5 9.5-4.2617 9.5-9.5 9.5zm0-18c-4.687 0-8.5 3.8135-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.8135 8.5-8.5-3.813-8.5-8.5-8.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.73,
    cy: 253.66,
    r: 5
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbag);
export default __webpack_public_path__ + "static/media/backbag.a38309c9efa6f21c37785176fc52d1a0.svg";
export { ForwardRef as ReactComponent };